import api from '@/apis/di/budgetSourceAPI';
import Crud from '@/stores/crudBase';
var crud = new Crud('budgetSource', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_budget_source',
    field: {
      key: 'budget_source_id',
      code: 'budget_source_code',
      name: 'budget_source_name',
      parentKey: 'parent_id',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
  /**
   * Chuyển nguồn không xóa khi thêm
   */
  async changeBudgetSource(context, payload) {
    let res = await api.changeBudgetSource(payload);
    // if (res) {
    //   //cập nhật danh sách
    //   context.commit('insertItem', res);
    // }
    return res;
  },
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
